export default "__VITE_ASSET__olse4giY__"